import { useTranslation } from 'next-i18next';
import React from 'react';

import CreateEditApproval from '@/modules/settings/approvals/components/Inventory/CreateEditApproval';
import CreateApprovalPathWrapper from '@/modules/settings/approvals/components/Operations/CreateApprovalPath';
import { Button } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import House from '~/images/shared/Packhouse.svg';
import Tracker from '~/images/shared/tracker.svg';

const ApprovalPathActions = () => {
  const { openModal } = useModal();
  const { t } = useTranslation();

  return (
    <div className='w-full'>
      <div className='flex flex-col gap-16'>
        <Button
          onClick={() =>
            openModal(<CreateApprovalPathWrapper />, {
              title: t('create-approval-path'),
            })
          }
          variant='text'
          size='none'
        >
          <span className='flex items-center gap-16 capitalize'>
            <Tracker width='24' height='24' />
            {t('operations')}
          </span>
        </Button>
        <Button
          onClick={() =>
            openModal(<CreateEditApproval />, {
              title: t('create-inventory-approval'),
            })
          }
          variant='text'
          size='none'
        >
          <span className='flex items-center gap-16'>
            <House width='24' height='24' />
            {t('warehouses#002')}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default ApprovalPathActions;
